import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { constant } from "common/constant";
import { getApi } from "common/services/api";
import { deleteApi } from "common/services/api";
import { putApi } from "common/services/api";
import { postApi } from "common/services/api";
import { API_PATHS } from "common/services/apiPaths";
import { toast } from "react-toastify";
import { policyData } from "services/Recruit/data/companyPolicyData";

export const addCompanyPolicy = createAsyncThunk(
  `companyPolicy/addCompanyPolicy`,
  async ({ values, resetForm }, { dispatch, rejectWithValue }) => {
    try {
      const response = await postApi(API_PATHS.CREATE_COMPANY_POLICY, values);
      toast.success(constant.companyPolicyCreateSuccess);

      // Fetch updated list after adding
      await dispatch(getCompanyPolicy());

      return response.data;
    } catch (error) {
      toast.error(constant.somethingWentWrong);
      return rejectWithValue(error.message || constant.apiReqFailed);
    }
  }
);
export const getCompanyPolicy = createAsyncThunk(
  `companyPolicy/getCompanyPolicy`,
  async (_, { rejectWithValue }) => {
    try {

      const response = await getApi(API_PATHS.CREATE_COMPANY_POLICY,);
      return response.data.data;
    } catch (error) {
      toast.error(constant.somethingWentWrong);
      return rejectWithValue(error.message || constant.apiReqFailed);
    }
  }
);

export const editCompanyPolicy = createAsyncThunk(
  "companyPolicy/editCompanyPolicy",
  async ({ policyId, values }, { dispatch, rejectWithValue }) => {
    try {
      const { policyName, description } = values;

      const response = await putApi(`${API_PATHS.CREATE_COMPANY_POLICY}/${policyId}`, { policyName, description });

      toast.success("Policy Updated Successfully");
      await dispatch(getCompanyPolicy());

      return response?.data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const addCompanySubPolicy = createAsyncThunk(
  `companyPolicy/addCompanySubPolicy`,
  async ({ values, resetForm }, { getState, dispatch, rejectWithValue }) => {
    try {
      const { policyId, ...formValue } = values;
      // Sub-policies are stored as rich text content (HTML) now.
      const updatedValue = {
        title: formValue.title,
        description: formValue.description,
        content: formValue.content,
      };
      const response = await postApi(`${API_PATHS.CREATE_COMPANY_POLICY}/${policyId}/sub-policies`, updatedValue);
      toast.success("SubPolicy Created Successfully");

      await dispatch(getCompanyPolicy());

      return response.data;

    } catch (error) {
      toast.error('Failed to create company sub policy');
      return rejectWithValue(error.message || constant.apiReqFailed);
    }
  }
);


export const editCompanySubPolicy = createAsyncThunk(
  "companyPolicy/editCompanySubPolicy",
  async ({ values, resetForm }, { getState, dispatch, rejectWithValue }) => {
    try {
      const { info, ...formValue } = values

      // Validate that info object and required IDs are present
      if (!info || !info.policyId || !info.subPolicyInfo || !info.subPolicyInfo.id) {
        throw new Error('Policy ID and Sub-Policy ID are required for update');
      }

      // Sub-policies are stored as rich text content (HTML) now.
      const updatedValue = {
        title: formValue.title,
        description: formValue.description,
        content: formValue.content,
      };
      const response = await putApi(`${API_PATHS.CREATE_COMPANY_POLICY}/${info?.policyId}/sub-policies/${info?.subPolicyInfo.id}`, updatedValue);

      toast.success("SubPolicy Updated Successfully");
      await dispatch(getCompanyPolicy());

      return response?.data;

    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);


export const deleteCompanyPolicy = createAsyncThunk(
  "companyPolicy/deleteCompanyPolicy",
  async (policyId, { getState, dispatch, rejectWithValue }) => {
    try {

      const response = await deleteApi(`${API_PATHS.CREATE_COMPANY_POLICY}/`, policyId);

      toast.success("Policy deleted successfully");
      await dispatch(getCompanyPolicy());

      return response?.data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);
export const deleteCompanySubPolicy = createAsyncThunk(
  "companyPolicy/deleteCompanySubPolicy",
  async (subPolicyInfo, { getState, dispatch, rejectWithValue }) => {
    try {
      const response = await deleteApi(`${API_PATHS.CREATE_COMPANY_POLICY}/`, `${subPolicyInfo.policyId}/sub-policies/${subPolicyInfo.subPolicyId}`);

      toast.success("Sub policy deleted successfully");
      await dispatch(getCompanyPolicy());

      return response?.data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);


const companyPolicySlice = createSlice({
  name: "companyPolicy",
  initialState: {
    data: [],
    loading: false,
    error: null,
    addLoading: false,
    getLoading: false,
    updateLoading: false,
    deleteLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCompanyPolicy.pending, (state) => { state.getLoading = true; })
      .addCase(getCompanyPolicy.fulfilled, (state, action) => {
        state.getLoading = false;
        state.data = action.payload;
      })
      .addCase(getCompanyPolicy.rejected, (state, action) => {
        state.getLoading = false;
        state.error = action.payload;
      })
      .addCase(addCompanyPolicy.pending, (state) => { state.addLoading = true; })
      .addCase(addCompanyPolicy.fulfilled, (state, action) => {
        state.addLoading = false;
        // state.data.push(action.payload);
      })
      .addCase(addCompanyPolicy.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
      })

      .addCase(editCompanyPolicy.pending, (state) => { state.updateLoading = true; })
      .addCase(editCompanyPolicy.rejected, (state, action) => {
        state.updateLoading = false;
      })
      .addCase(editCompanyPolicy.fulfilled, (state, action) => {
        // state.data = action.payload;
        state.updateLoading = false;
      })

      .addCase(addCompanySubPolicy.pending, (state) => { state.addLoading = true; })
      .addCase(addCompanySubPolicy.fulfilled, (state, action) => {
        state.addLoading = false;
        // state.data = action.payload;
      })
      .addCase(addCompanySubPolicy.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
      })

      .addCase(editCompanySubPolicy.pending, (state) => { state.updateLoading = true; })
      .addCase(editCompanySubPolicy.rejected, (state, action) => {
        state.updateLoading = false;
        state.error = action.payload;
      })
      .addCase(editCompanySubPolicy.fulfilled, (state, action) => {
        state.updateLoading = false;
      })

      .addCase(deleteCompanyPolicy.pending, (state) => { state.deleteLoading = true; })
      .addCase(deleteCompanyPolicy.fulfilled, (state, action) => {
        state.deleteLoading = false;
      })
      .addCase(deleteCompanyPolicy.rejected, (state, action) => {
        state.deleteLoading = false;
        state.error = action.payload;
      })
      .addCase(deleteCompanySubPolicy.pending, (state) => { state.deleteLoading = true; })
      .addCase(deleteCompanySubPolicy.fulfilled, (state, action) => {
        // state.data = action.payload;
        state.deleteLoading = false;
      })
      .addCase(deleteCompanySubPolicy.rejected, (state, action) => {
        state.deleteLoading = false;
        state.error = action.payload;
      })
      ;
  },
});

export default companyPolicySlice.reducer;
